import {useEffect, useMemo} from 'react';

export type HeadingEntry = { slug: string; text: string; level: number };

type ContentTocProps = {
  headings: HeadingEntry[];
  activeSlug?: string | null;
  onSelect: (slug: string) => void;
};

export function ContentToc({headings, activeSlug, onSelect}: ContentTocProps) {
  const items = useMemo(() => {
    return (headings || []).filter((h) => h.slug && h.text);
  }, [headings]);

  if (!items.length) return null;

  return (
    <aside className="hidden xl:flex w-56 shrink-0 border-l border-slate-200/50">
      <div className="sticky top-0 max-h-[calc(100vh-4rem)] overflow-y-auto px-3 py-4">
        <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-500">On this page</p>
        <ul className="space-y-1 text-sm">
          {items.map((h) => (
            <li key={h.slug} className={h.level >= 3 ? 'pl-4' : ''}>
              <button
                className={`block w-full truncate text-left transition hover:text-slate-900 ${
                  activeSlug === h.slug ? 'font-medium' : 'text-slate-600'
                }`}
                style={activeSlug === h.slug ? {color: 'var(--accent-color, #2563eb)'} : undefined}
                onClick={() => onSelect(h.slug)}
                aria-current={activeSlug === h.slug ? 'true' : undefined}
              >
                {h.text}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}
